export const ADD_TEMPLATE = 'ADD_TEMPLATE';
